export default __webpack_public_path__ + "static/media/home-5-slider-image-2.2011d818.jpg";